import type { TEmitterType } from '@semios/app-platform-values-helpers-and-types'
import { getApplicationRateFromFlowRate, type TApplicationRate } from 'App/dashboards/_utils/applicationRate'
import { isEqual, uniqWith } from 'lodash'
import type { TPoint, TProperty } from 'stores/fieldAssetStore/helperTypes'

export const getZoneApplicationRateByEmitterType = (
  property: TProperty,
  point: TPoint,
): Partial<Record<TEmitterType, TApplicationRate>> => {
  const ratesByEmitterType: Partial<Record<TEmitterType, (TApplicationRate | null)[]>> = {}
  const zoneEmitterIds = point.irrigationEmitterZoneIds ?? []

  zoneEmitterIds.forEach((zoneEmitterId) => {
    const emitterType = zoneEmitterId.split('|||')[1] as TEmitterType
    const rate = getApplicationRateFromFlowRate(property.irrigationZoneEmitters?.[zoneEmitterId]?.flowRate)

    ratesByEmitterType[emitterType] = [...(ratesByEmitterType[emitterType] ?? []), rate]
  })

  const rateByEmitterType: Partial<Record<TEmitterType, TApplicationRate>> = {}

  Object.entries(ratesByEmitterType).forEach(([emitterType, rates]) => {
    const [rate, ...others] = uniqWith(rates, isEqual)

    if (rate && !others.length) rateByEmitterType[emitterType as TEmitterType] = rate
  })

  return rateByEmitterType
}
